import React, { useState, useEffect, useRef } from 'react'
import Navigation from '../../Components/Navigation'
import ShoppingCart from '../../Components/ShoppingCart'
import { useHistory } from 'react-router-dom'
import './crearCotizacion.css'
import { Row, Col } from 'react-bootstrap'
import MetodoEntrega from '../../Components/MetodoEntrega'
import { useSelector, useDispatch } from 'react-redux'
import {
  updateCotizacionCompany,
  addSalesAgent,
  addPriceList,
  cotizacionReStart,
} from '../../redux/actions/cotizacionActions'
import { emptyCart } from '../../redux/actions/cartActions'
import ProductSearch from '../../Components/ProductSearch'
import MaterialsCalculator from 'Components/MaterialsCalculator/MaterialCalculator'

function CrearCotizacion(props) {
  const productsRef = useRef(null)
  const dispatch = useDispatch()
  const history = useHistory()
  // ALGOLIA FILTERING VARIABLES
  // const [page, setPage] = useState(0)
  // VARIABLE PARA MOSTRAR METODO DE ENTREGA
  const [mostrarMetodoEntrega, setMostrarMetodoEntrega] = useState(false)
  const [showMaterialsCalculatorPDP, setShowMaterialsCalculatorPDP] =
    useState(false)
  const [productDetail, setProductDetail] = useState(null)
  const [direccion, setDireccion] = useState(null)
  const [productCart] = useState([])
  // CLIENT TO COTIZACION
  const [clienteMetodoEntrega, setClienteMetodoEntrega] = useState(null)
  const salesAgent = useSelector(
    state => state.login.user.CustomerInfo.CustomerId
  )

  const selectedWarehouse = useSelector(state => state?.company)
  // CHOOSEN ADDRESS
  const [selectedAddress, setSelectedAddress] = useState(null)
  const [promisedDate, setPromisedDate] = useState(null)
  const [isList] = useState(history?.location?.state?.from === 'Mis Listas')

  // HANDLE PARA CAMBIAR MOSTRAR METODO ENTREGA
  const handleMetodoEntrega = () => {
    setMostrarMetodoEntrega(true)
  }
  const handleMetodoEntregaTwo = () => {
    setMostrarMetodoEntrega(false)
  }
  const quoteHeader = useSelector(state => state?.cotizacion?.QuoteHeader)
  useEffect(() => {
    if (!props.edit && !props.clone && !isList) {
      dispatch(emptyCart())
      dispatch(cotizacionReStart())
    }

    if (props.edit || props.clone) {
      // set warehouseid form quotation if want to put the lines put Lines[0]?.WarehouseId

      const homeAddress = {
        Address_AddressId: quoteHeader?.Address_AddressId,
        PromisedDate: quoteHeader?.PromisedDate,
      }

      const warehouse = {
        WarehouseId: quoteHeader?.WarehouseId,
        WarehouseDescription: quoteHeader?.WarehouseDescription,
        WarehouseAddress: quoteHeader?.WarehouseAddress,
        WarehouseCode: quoteHeader?.WarehouseCode,
        WarehouseName: quoteHeader?.WarehouseName,
        Description: quoteHeader?.WarehouseDescription,
      }
      setSelectedAddress(
        quoteHeader?.Address_AddressId ? homeAddress : warehouse
      )
    }
  }, [])

  useEffect(() => {
    if (!props.edit && !props.clone) {
      dispatch(addPriceList(undefined))
      dispatch(addSalesAgent(salesAgent))
    }
  }, [])

  useEffect(() => {
    if (!props.edit && !props.clone) {
      dispatch(
        updateCotizacionCompany({
          CompanyCode: selectedWarehouse.CompanyCode,
          CompanyName: selectedWarehouse.CompanyName,
          CompanyId: selectedWarehouse.CompanyId,
          WarehouseCode: selectedWarehouse.WarehouseCode,
          WarehouseId: selectedWarehouse.WarehouseId,
          WarehouseDescription: selectedWarehouse.WarehouseDescription,
          WarehouseName: selectedWarehouse.WarehouseName,
          WarehouseAddress: selectedWarehouse.WarehouseAddress,
          DefaultWarehouse: selectedWarehouse.DefaultWarehouse,
        })
      )
    }
  }, [selectedWarehouse])

  useEffect(() => {
    if (quoteHeader?.PromisedDate) {
      setPromisedDate(quoteHeader?.PromisedDate)
    }
  }, [quoteHeader?.PromisedDate])

  return (
    <>
      <Navigation data-testid="container-navigation-create-quotation" />

      <div
        className="crear-cotizacion-main"
        data-testid="container-create-quotation">
        <Row>
          {mostrarMetodoEntrega && clienteMetodoEntrega ? (
            <Col
              xl={8}
              lg={8}
              md={8}
              sm={12}
              xs={12}
              data-testid="modal-delivery-method">
              <MetodoEntrega
                clienteMetodoEntrega={clienteMetodoEntrega}
                setSelectedAddress={setSelectedAddress}
                selectedAddress={selectedAddress}
                productsSelected={productCart}
                onCloseMetodoEntrega={handleMetodoEntregaTwo}
                setDireccion={setDireccion}
                autoClose={false}
                setPromisedDate={setPromisedDate}
                promisedDate={promisedDate}
                isEditMode={props.edit}
              />
            </Col>
          ) : (
            <Col
              xl={8}
              lg={7}
              md={12}
              sm={12}
              data-testid="container-products-quotation"
              className={
                showMaterialsCalculatorPDP
                  ? 'productos-cotizacion-left blur'
                  : 'productos-cotizacion-left'
              }
              style={{ position: 'relative' }}
              ref={productsRef}>
              <ProductSearch
                productsRef={productsRef}
                setShowMaterialsCalculatorPDP={setShowMaterialsCalculatorPDP}
                setProductDetail={setProductDetail}
              />
            </Col>
          )}
          <Col
            xl={4}
            lg={5}
            md={12}
            sm={12}
            data-testid="container-cart-quotation"
            className={
              showMaterialsCalculatorPDP ? 'scrollable-container' : ''
            }>
            {showMaterialsCalculatorPDP ? (
              <MaterialsCalculator
                showCalculator={showMaterialsCalculatorPDP}
                setShowCalculator={setShowMaterialsCalculatorPDP}
                productDetail={productDetail}
              />
            ) : (
              <ShoppingCart
                handleMetodoEntrega={handleMetodoEntrega}
                setClienteMetodoEntrega={setClienteMetodoEntrega}
                setSelectedAddress={setSelectedAddress}
                selectedAddress={selectedAddress}
                direccion={direccion}
                setDireccion={setDireccion}
                edit={props.edit}
                clone={props.clone}
                productsRef={productsRef}
                editarCotizacion={() => {
                  setMostrarMetodoEntrega(true)
                  setClienteMetodoEntrega(true)
                }}
                setShowMaterialsCalculatorPDP={setShowMaterialsCalculatorPDP}
                promisedDate={promisedDate}
                setPromisedDate={setPromisedDate}
              />
            )}
          </Col>
        </Row>
      </div>
    </>
  )
}

export default CrearCotizacion
